export const FILTER_VALUE_SEPARATOR = '^';
export const DURATION_FILTER_VALUE_SEPARATOR = ':';
export const RANGE_FILTER_SEPARATOR = '>';
export const FILTER_MATCH_TYPE_SEPARATOR = ':';
export const COMPANY_ID_FILTER_SEPARATOR = '::';
export const BULK_FILTER_VALUE_SEPARATOR = '::';
